import React from "react";
import PageShell from "../../components/layout/PageShell";

export default function Organigramme() {
  return (
    <PageShell
      title="Organigramme"
      subtitle="Structure organisationnelle de l'École de la Magistrature"
    >
      {/* Introduction */}
      <section className="ema-block">
        <h2 className="ema-h3">Structure organisationnelle</h2>
        <p className="ema-paragraph">
          L'organigramme de l'École de la Magistrature présente la structure hiérarchique et fonctionnelle de
          l'institution, définissant les responsabilités et les relations entre les différents services et
          départements.
        </p>
      </section>

      <div className="ema-divider" />

      {/* Direction */}
      <section className="ema-block">
        <h2 className="ema-h3">Direction générale</h2>
        <div className="ema-panel" style={{ marginTop: 14 }}>
          <h3 className="ema-h3">Directeur général</h3>
          <p className="ema-paragraph">
            Responsable de la direction stratégique et opérationnelle de l'école. Il supervise l'ensemble des
            directions et services, et assure la mise en œuvre de la vision et de la mission de l'institution.
          </p>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Directions */}
      <section className="ema-block">
        <h2 className="ema-h3">Directions sous la responsabilité du directeur général</h2>
        <div className="ema-timeline" style={{ marginTop: 14 }}>
          <Timeline n="1" title="Direction des Études" text="Conception et mise en œuvre des programmes de formation initiale et continue." />
          <Timeline n="2" title="Direction Administrative et Financière" text="Gestion des ressources humaines, financières et matérielles." />
          <Timeline n="3" title="Direction des Partenariats" text="Développement des relations avec les partenaires institutionnels et internationaux." />
          <Timeline n="4" title="Direction de la Communication" text="Gestion de la communication interne et externe de l'institution." />
        </div>
      </section>

      <div className="ema-divider" />

      {/* Services */}
      <section className="ema-block">
        <h2 className="ema-h3">Services opérationnels</h2>
        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <div className="ema-panel">
            <h3 className="ema-h3">Service Pédagogique</h3>
            <p className="ema-paragraph">
              Coordination des enseignants, préparation des supports pédagogiques et suivi des apprenants.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Service des Stages</h3>
            <p className="ema-paragraph">
              Organisation et suivi des stages en juridiction pour les apprenants.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Service des Ressources Humaines</h3>
            <p className="ema-paragraph">
              Gestion du personnel, recrutement et développement des compétences.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Service Financier</h3>
            <p className="ema-paragraph">
              Gestion budgétaire, comptabilité et contrôle financier.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Service Technique et Logistique</h3>
            <p className="ema-paragraph">
              Maintenance des infrastructures et gestion des équipements.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Service Informatique</h3>
            <p className="ema-paragraph">
              Support technique et gestion des systèmes d'information.
            </p>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Instances */}
      <section className="ema-block">
        <h2 className="ema-h3">Instances de gouvernance</h2>
        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <div className="ema-panel">
            <h3 className="ema-h3">Conseil d'Administration</h3>
            <p className="ema-paragraph">
              Organe de décision stratégique qui définit les orientations générales et approuve les décisions
              majeures de l'institution.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Conseil Pédagogique</h3>
            <p className="ema-paragraph">
              Instance consultative qui émet des avis sur les programmes pédagogiques et les méthodes
              d'enseignement.
            </p>
          </div>
        </div>
      </section>
    </PageShell>
  );
}

function Timeline({ n, title, text }) {
  return (
    <div className="ema-step">
      <div className="ema-step-num">{n}</div>
      <div className="ema-step-body">
        <h3 className="ema-h3" style={{ margin: 0 }}>{title}</h3>
        <p className="ema-paragraph" style={{ marginTop: 10 }}>{text}</p>
      </div>
    </div>
  );
}
